import { environment } from "src/environments/environment";


if( (window.location.host).indexOf('localhost') != -1)
{
    environment.config.webSocket = 'http://localhost:3000';
}



const rootPath = (dataVar: any) => {

    let url: any = environment.config.baseUrl;
    let path = url[dataVar] + environment.config.apiVer;
    return path;
}


export const rootEnv: any = environment;

export const apiUrl: any = {

    _common:
    {
        dropDown:
        {
            url: "/MasterList/CommonBindDropFun", method: "POST"
        },
        clusterList:
        {
            url: "/MasterList/Cluster/List?startpageindex/lastpageindex/search_key", method: "GET"
        },
        updateStatusCluster:
        {
            url: "/MasterList/Cluster/Deactivate", method: "PUT"
        },
        updateCluster:
        {
            url: "/MasterList/Cluster/Update", method: "PUT"
        },
        addCluster:
        {
            url: "/MasterList/Cluster/Create", method: "POST"
        },
        companyList:
        {
            url: "/MasterList/CompanyLocation/List?startpageindex/lastpageindex/search_key", method: "GET"
        },
        updateStatusCompany:
        {
            url: "/MasterList/CompanyLocation/Deactivate", method: "PUT"
        },
        updateCompany:
        {
            url: "/MasterList/CompanyLocation/Update", method: "PUT"
        },
        addCompany:
        {
            url: "/MasterList/CompanyLocation/Create", method: "POST"
        },
        leadCampaignList:
        {
            url: "/MasterList/ShowLeadCampaignList?page_index/page_size/lead_campaign_name", method: "GET"
        },
        updateStatusLeadCampaign:
        {
            url: "/MasterList/UpdateStatusLeadCampaign", method: "POST"
        },
        UpdateLeadCampaign:
        {
            url: "/MasterList/UpdateLeadCampaign", method: "POST"
        },
        addLeadCampaign:
        {
            url: "/MasterList/CreateLeadCampaign", method: "POST"
        },
        leadSourceList:
        {
            url: "/MasterList/ShowLeadSourceList", method: "POST"
        },
        updateStatusLeadSource:
        {
            url: "/MasterList/UpdateStatusLeadSource", method: "POST"
        },
        UpdateLeadSource:
        {
            url: "/MasterList/UpdateLeadSource", method: "POST"
        },
        addLeadSource:
        {
            url: "/MasterList/CreateLeadSource", method: "POST"
        },
        leadMediumList:
        {
            url: "/MasterList/Lead/LeadMediumList?startpageindex/lastpageindex/search_key", method: "GET"
        },
        updateStatusLeadMedium:
        {
            url: "/MasterList/Lead/DeactivateLeadMedium", method: "PUT"
        },
        UpdateLeadMedium:
        {
            url: "/MasterList/Lead/UpdateLeadMedium", method: "PUT"
        },
        addLeadMedium:
        {
            url: "/MasterList/Lead/CreateLeadMedium", method: "POST"
        },
        leadCheckList:
        {
            url: "/MasterList/Lead/ShowLeadCheckList?startpageindex/lastpageindex/search_key", method: "GET"
        },
        updateStatusLeadCheck:
        {
            url: "/MasterList/Lead/DeactivateLeadCheckList", method: "PUT"
        },
        UpdateLeadCheckList:
        {
            url: "/MasterList/Lead/UpdateLeadCheckList", method: "PUT"
        },
        addLeadCheckList:
        {
            url: "/MasterList/Lead/CreateLeadCheckList", method: "POST"
        },
        lookupList:
        {
            url: "/MasterList/ShowLookupList?startpageindex/lastpageindex/search_key", method: "GET"
        },
        updateStatusLookup:
        {
            url: "/MasterList/DeactivateLookup", method: "POST"
        },
        UpdateLookup:
        {
            url: "/MasterList/UpdateLookup", method: "POST"
        },
        addLookup:
        {
            url: "/MasterList/CreateLookup", method: "POST"
        },
        logHistory:
        {
            url: "/MasterList/ShowLogHistory?mobile/page_index/page_size", method: "GET"
        },
        getDepartmentList:
        {
            url: "/MasterList/Master/DepartmentList?startpageindex/lastpageindex/search_key", method: "GET"
        },
        CreateDepartment:
        {
            url: "/MasterList/Master/CreateDepartment", method: "POST"
        },
        UpdateDepartment:
        {
            url: "/MasterList/Master/UpdateDepartment", method: "PUT"
        },
        DeactivateDepartment:
        {
            url: "/MasterList/Master/DeactivateDepartment", method: "PUT"
        },
        getDesignationList:
        {
            url: "/MasterList/Master/DesignationList?/startpageindex/lastpageindex/search_key", method: "GET"
        },
        CreateDesignation:
        {
            url: "/MasterList/Master/CreateDesignation", method: "POST"
        },
        UpdateDesignation:
        {
            url: "/MasterList/Master/UpdateDesignation", method: "PUT"
        },
        DeactivateDesignation:
        {
            url: "/MasterList/Master/DeactivateDesignation", method: "PUT"
        },
        AgentTargetList:
        {
            url: "/MasterList/Master/AgentTargetList?startpageindex/lastpageindex/search_key", method: "GET"
        },
        CreateAgentTarget:
        {
            url: "/MasterList/Master/CreateAgentTarget", method: "POST"
        },
        UpdateAgentTarget:
        {
            url: "/MasterList/Master/UpdateAgentTarget", method: "PUT"
        },
        DeactivateAgentTarget:
        {
            url: "/MasterList/Master/DeactivateAgentTarget", method: "PUT"
        },
        CreateKnowledge:
        {
            url: "/MasterList/Master/CreateKnowledge", method: "POST"
        },
        UpdateKnowledge:
        {
            url: "/MasterList/Master/UpdateKnowledge", method: "PUT"
        },
        DeactivateKnowledge:
        {
            url: "/MasterList/Master/DeactivateKnowledge", method: "PUT"
        },
        KnowledgeList:
        {
            url: "/MasterList/Master/KnowledgeList", method: "GET"
        },
        GetClientDetails:
        {
            url: "/MasterList/Master/GetClientDetails", method: "POST"
        },
        DeactivateClientMaster:
        {
            url: "/MasterList/Master/DeactivateClientMaster", method: "PUT"
        },
        CreateClient:
        {
            url: "/MasterList/Master/CreateClient", method: "POST"
        },
        UpdateCreateClient:
        {
            url: "/MasterList/Master/UpdateCreateClient", method: "POST"
        },
        GetSalesDetails:
        {
            url: "/MasterList/Master/GetSalesDetails", method: "POST"
        },
        ConfigList:
        {
            url: "/MasterList/Master/ConfigList?startpageindex/lastpageindex/search_key", method: "GET"
        },
        CreateConfig:
        {
            url: "/MasterList/Master/CreateConfig", method: "POST"
        },
        UpdateConfig:
        {
            url: "/MasterList/Master/UpdateConfig", method: "PUT"
        },
        DeactivateConfig:
        {
            url: "/MasterList/Master/DeactivateConfig", method: "PUT"
        }
    },
    _user:
    {
        authLogin:
        {
            url: "/Login/Login", method: "POST"
        },
        authOTP:
        {
            url: "/Auth/OTP", method: "POST"
        },
        verifyOTP:
        {
            url: "/Auth/VerifyOTP", method: "POST"
        },
        resetPassword:
        {
            url: "/Auth/ResetPassword", method: "POST"
        },
        authLogout:
        {
            url: "/Login/Logout", method: "POST"
        },


        getRolesAndRights: {
            url: "/UserManagement/RolesAndRights", method: "GET"
        },
        userList:
        {
            url: "/UserManagement/ShowUserList?page_index/page_size/emp_name/mobile", method: "GET"
        },
        updateUserStatus:
        {
            url: "/UserManagement/UpdateUserStatus", method: "POST"
        },
        userCredential:
        {
            url: "/UserManagement/ResetUserCredential", method: "POST"
        },
        createUser:
        {
            url: "/UserManagement/CreateUser", method: "POST"
        },
        updateUser:
        {
            url: "/UserManagement/UpdateUser", method: "POST"
        },




        roleList:
        {
            url: "/UserManagement/ShowRoleList?page_index/page_size/role_name", method: "GET"
        },
        updateStatusRole:
        {
            url: "/UserManagement/UpdateStatusRole", method: "POST"
        },
        updateRole:
        {
            url: "/UserManagement/UpdateRole", method: "POST"
        },
        addRole:
        {
            url: "/UserManagement/CreateRole", method: "POST"
        },


        menuList:
        {
            url: "/UserManagement/ShowModuleList?page_index/page_size/module_name", method: "GET"
        },
        updateStatusMenu:
        {
            url: "/UserManagement/UpdateStatusModule", method: "POST"
        },
        updateMenu:
        {
            url: "/UserManagement/UpdateModule", method: "POST"
        },
        addMenu:
        {
            url: "/UserManagement/CreateModule", method: "POST"
        },
        mappedMenu:
        {
            url: "/UserManagement/ShowRoleModuleMapList?role_name", method: "GET"
        },
        createRoleModuleMap:
        {
            url: "/UserManagement/CreateRoleModuleMap", method: "POST"
        },


        actionList:
        {
            url: "/UserManagement/ShowActionList?page_index/page_size/action_name", method: "GET"
        },
        updateStatusAction:
        {
            url: "/UserManagement/UpdateStatusAction", method: "POST"
        },
        updateAction:
        {
            url: "/UserManagement/UpdateAction", method: "POST"
        },
        addAction:
        {
            url: "/UserManagement/CreateAction", method: "POST"
        },
        mappedAction:
        {
            url: "/UserManagement/ShowRoleActionMapList?role_name/page_index/page_size", method: "GET"
        },
        createRoleActionMap:
        {
            url: "/UserManagement/CreateRoleActionMap", method: "POST"
        }


    },
    _leads: {

        getLeads:
        {
            url: "/Lead/ShowAllLead", method: "POST"

        },
        getReminderleads:
        {
            url: "/Lead/ShowAllCallReminderLead", method: "POST"

        },

        leadDetail:
        {
            url: "/Lead/ShowLeadDetailsByid?lead_capture_id", method: "GET"

        },
        activityLog:
        {
            url: "/Lead/ShowLeadActivities?lead_capture_id/page_index/page_size", method: "GET"
        },


        createLead:
        {
            url: "/Lead/CreateLead", method: "POST"

        },
        updateLead:
        {
            url: "/Lead/UpdateLead", method: "POST"

        },
        downloadPrescription:
        {
            url: "/Lead/DownloadPrescription?fileurl", method: "GET"

        },
        releaseLead:
        {
            url: "/Lead/LeadOpenandRelease?leadid", method: "GET"

        },
        leadActivity:
        {
            url: "/Lead/LeadActivity", method: "POST"

        },
        completedLead:
        {
            url: "/Lead/ShowAllCompletedLead", method: "POST"
        },
        completedLeadDetailsByid:
        {
            url: "/Lead/ShowCompletedLeadDetailsByid?lead_capture_id", method: "GET"
        },
        ShowAttemptedLeadDetailsByid:
        {
            url: "/Lead/ShowAttemptedLeadDetailsByid?lead_capture_id", method: "GET"
        },
        leadsCountDetails: {
            url: "/Lead/GetLeadsCountDetails", method: "POST"
        },
        leadAssign:
        {
            url: "/Lead/LeadAssignByHOD", method: "POST"
        },
        leadsUserOnHoldandStatus:
        {
            url: "/Lead/LeadsUserOnHoldandRelease?is_on_hold", method: "GET"
        },
        leadActions: {
            url: "/Lead/LeadActions", method: "GET"
        },
        agentList: {
            url: "/Lead/GetActiveAgents?page_size/page_index", method: "GET"
        },
        showAllLeadByMobileNo: {
            url: "/Lead/ShowAllLeadByMobileNo?mobile/page_size/page_index", method: "GET"
        },
        showAllBookingByMobileNo:
        {
            url: "/Lead/ShowAllBookingByMobileNo?mobile/page_size/page_index", method: "GET"
        },
        ReminderNotification:
        {
            url: "/Lead/CallReminderNotification", method: "GET"
        },
        freeLeadNotification:
        {
            url: "/Lead/CountLeadsFreeUsersNotifications", method: "GET"
        },
        leadsfreeUsers:
        {
            url: "/Lead/LeadsfreeUsers", method: "GET"
        },
        RoundRobinOnOff:
        {
            url: "/Lead/RoundRobin_On_Off?is_round_robin", method: "GET"
        },
        leadPreferredAgent:
        {
            url: "/Lead/LeadPreferredAgent?lead_id/preferred_agent", method: "GET"
        },
        readReminderNotification:
        {
            url: "/Lead/ReadReminderNotification", method: "GET"
        },
        pendingLeads: {
            url: "/Lead/GetUserActionDetails", method: "GET"
        },
        bulkLeadUpload:
        {
            url: "/Lead/BulkUploadLeadFile", method: "POST"
        },
        getBulkLead:
        {
            url: "/Lead/ShowAllBulkLead", method: "POST"
        },
        getAgentTarget:
        {
            url: "/Lead/GetAgentTarget?page_size/page_index", method: "GET"
        },
        GetAgentTarget:
        {
            url: "/Lead/GetAgentTarget?page_size/page_index", method: "GET"
        },
        GetLeadsCountDetails:
        {
            url: "/Lead/GetLeadsCountDetails", method: "POST"
        },
        ShowAllAttemptedFreeLead:
        {
            url: "/Lead/ShowAllAttemptedFreeLead", method: "POST"
        },
        GetAgentKnowledgeCenter: {
            url: "/Lead/GetAgentKnowledgeCenter", method: "GET"
        },
        GetAverageBookingByMobileNo: {
            url: "/Lead/GetAverageBookingByMobileNo?mobile", method: "GET"
        },
        ShowBookingNamesByMobileNo: {
            url: "/Lead/ShowBookingNamesByMobileNo?mobile", method: "GET"
        },
        UserLoginDetails: {
            url: "/Lead/UserLoginDetails?user_token", method: "GET"
        },
        UserBreakDetails: {
            url: "/Lead/UserBreakDetails?user_token", method: "GET"
        },
        GenerateCRMMISReport: {
            url: "/Lead/GenerateCRMMISReport?fromdate/todate/mis_type", method: "GET"
        },
        GetPatientListbyMobile: {
            url: "/Lead/GetPatientListbyMobile?mobile", method: "GET"
        },
        GetAmeyoCallRecordsCount: {
            url: "/Lead/GetAmeyoCallRecordsCount?user_token", method: "GET"
        }
    },
    _booking:
    {
        findCCLab:
        {
            url: "/LeadBooking/FindCCLab", method: "POST"
        },
        showTestList:
        {
            url: "/LeadBooking/ShowTestList", method: "POST"
        },
        addAddress:
        {
            url: "/LeadBooking/AddAddress", method: "POST"
        },
        addressByMobile:
        {
            url: "/LeadBooking/GetAddressByMobile", method: "POST"
        },
        addBooking:
        {
            url: "/LeadBooking/AddBooking", method: "POST"
        },
        getBookingList: {
            url: "/LeadBooking/ShowbookingList", method: "POST"
        },
        getBookingDetails: {
            url: "/LeadBooking/ShowBookingDetails", method: "POST"
        },
        addChildBooking: {
            url: "/LeadBooking/AddChildBooking", method: "POST"
        },
        getBookingDetail: {
            url: "/LeadBooking/ShowBookingDetails", method: "POST"
        },
        RescheduleBooking: {
            url: "/LeadBooking/RescheduleBooking", method: "POST"
        },
        CancelBooking: {
            url: "/LeadBooking/CancelBooking", method: "POST"
        },
        ShowBookingPaymentDetails: {
            url: "/LeadBooking/ShowBookingPaymentDetails", method: "POST"
        },
        CreatePaymentLink: {
            url: "/LeadBooking/CreatePaymentLink", method: "POST"
        },
        UpdateBooking: {
            url: "/LeadBooking/UpdateBooking", method: "POST"
        },
        ShowBookingHistory: {
            url: "/LeadBooking/ShowBookingHistory", method: "POST"
        },
        profileTest: {
            url: "/LeadBooking/ShowProfileTest", method: "POST"
        },
        finalBooking:
        {
            url: '/LeadBooking/CompleteBooking', method: "POST"
        },
        SamplifyWebhookDetail: {
            url: '/SamplifyData/SamplifyWebhookDetail', method: "POST"
        },
        getPaymentList: {
            url: "/LeadBooking/ShowBookingPaymentSummamary", method: 'POST'
        }

    },
    _payment: {
        orderResponce:
        {
            url: "/PaymentOrder/GetResponse", method: "POST"
        },
        VerifyPaymentStatus: {
            url: '/PaymentOrder/VerifyPaymentStatus', method: "POST"
        }

    },

    _inbound: {
        interaction:
        {
            url: "/Dashboard/Dashboard/Interaction?view/from/to", method: "GET"
        },
        interactionList:
        {
           url: "/Interaction/GetAll?filterID/assigned_to/status/date_from/date_to/category_id/sub_category_id/last_updated_at/channelType/channel/page_index/page_size/sort_by/order_by", method: "GET"
        },
        interactionDetail:
        {
            url: "/Interaction/", method: "GET"
        },
        categoryList:
        {
            url: "/Common/GetCategory", method: "GET"
        },
        departmentList: {
            url: "/Common/GetDepartment?ticket_id", method: "GET"
        },
        userDetails: {
            url: "/Common/User", method: "GET"
        },
        ticketList: {
            url: "/Ticket/GetAll?filterID/assigned_to/departmentId/status/date_from/date_to/user_department_id/page_index/page_size/sort_by/order_by/store_id/category_id/sub_category_id/division/filter_id/searchText", method: "GET"
        },
        ticketNotes: {
            url: "/Ticket/", method: "GET"
        },
        updateInt:
        {
            url: "/Interaction/", method: "PUT"
        },
        createInt:
        {
            url: "/Interaction/Create", method: "POST"
        },
        interactionSearch:
        {
            url: "/Interaction/Search?filterId/searchText/page_index/page_size/sort_by/order_by", method: "GET"
        },
        ticketSearch:
        {
            url: "/Ticket/Search?filterId/searchText/page_index/page_size/sort_by/order_by", method: "GET"
        },
        createTicket:
        {
            url: "/Interaction/", method: "POST"
        },
        searchTicketByInt:
        {
            url: "/Interaction/", method: "GET"
        },
        ticketDetail:
        {
            url: "/Ticket/", method: "GET"
        },
        getChildTickets:
        {
            url: "/Ticket/", method: "GET"
        },
        updateTicket:
        {
            url: "/Ticket/", method: "PUT"
        },
        getWorkType:
        {
            url: "/Common/GetWorkType", method: "GET"

        },
        updateWorkType:
        {
            url: "/Common/UpdateWorkType", method: "PUT"

        },
        assignToDepartment:
        {
            url: "/Ticket/AssignToDepartment/", method: "POST"
        },
        uploadAttachment:
        {
            url: "/Attachment/AddAttachment", method: "POST"
        },
        getAgentList:
        {
            url: "/Common/Agents", method: "GET"
        },
        resolved:
        {
            url: "/Interaction/Resolved", method: "PUT"
        },
        resolvedTicket:
        {
            url: "/ticket/Resolved", method: "PUT"
        },
        reopenTicket:
        {
            url: "/ticket/Reopen", method: "PUT"
        },
        bulkAssign:
        {
            url: "/Interaction/BulkSelfAssign", method: "PUT"
        },
        bulkClose:
        {
            url: "/Interaction/BulkClose", method: "PUT"
        },
        ticketConversation:
        {
            url: "/Ticket/", method: "POST"
        },
        getTicktConversation:
        {
            url: "/Ticket/", method: "GET"
        },
        intConversation:
        {
            url: "/Interaction/", method: "POST"
        },
        getIntConversation:
        {
            url: "/Interaction/", method: "GET"
        },
        updateCustomer:
        {
            url: "/Customer/", method: "PUT"
        },
        getCustomerData:
        {
            url: "/Customer/", method: "GET"  
        },
        createCustomerData:
        {
            url: "/Customer/Create", method: "POST"  
        },
        downloadAttachment:
        {
            url: "/Common/", method: "GET" 
        },
        bulkEmail:{
            url: "/Common/SendBulkEmail", method: "POST" 
        },
        associatedInteractions:{
            url: "/Ticket/", method: "GET"
        },
        associatedTickets:{
            url: "/Ticket/", method: "GET"
        },
        clusterDetails:{
            url: "/Common/Cluster", method: "GET"
        },
        getAllReports:{
            url: "/Reports/GetReportTypes", method: "GET"
        },
        getReportData:{
            url: "/Reports/GetReport?reportTypeId/status/date_from/date_to", method: "GET"
        },
        bulkTicketAssign:
        {
            url: "/Ticket/BulkSelfAssign", method: "PUT"
        },
        bulkDeleteTicket:
        {
            url: "/Ticket/BulkDeleteTicket", method: "POST"
        },
        bulkCloseTicket:
        {
            url: "/Ticket/BulkCloseTicket", method: "POST"
        },
        addReminder:
        {
            url: "/Ticket/", method: "POST"
        },
        senderList:
        {
            url: "/Common/Senders", method: "GET" 
        },
        searchCustomer:
        {
            url: "/Customer/Search?first_name/last_name/mobile/email/page_index/page_size", method: "GET" 
        },
        getAgentsDetails:
        {
            url: "/Common/GetAgentsDetails" , method: "GET" 
        },
        createNewTicket:
        {
            url: "/Ticket/CreateTicket" , method: "POST" 
        },
        createNewITTicket:
        {
            url: "/Ticket/CreateTicketITSupport" , method: "POST" 
        },
        createTicketCustomer:
        {
            url: "/Ticket/CreateTicketCustomer" , method: "POST" 
        },
        getStoreMap:
        {
            url: "/Ticket/GetTicketByStoreMap" , method: "GET" 
        },
        rollbackNotes:
        {
            url: "/Ticket/UndoTicketCustomerConversation" , method: "POST" 
        },
        checkBillNumberStyleNumber:
        {
            url: "/Ticket/CheckBillNumberStyleNumber", method: "POST" 
        },
        getplatformList:
        {
            url: "/Common/Platform", method: "GET"  
        },
        uploadMarketPlaceFile:
        {
            url: "/MarketplaceExcel/Upload", method: "POST"   
        } ,
        downloadMarketPlaceFile:
        {
            url: "/MarketplaceExcel/Download", method: "POST"   
        },
        createTicketArticles:
        {
            url: "/Ticket/CreateTicketArticles", method: "POST"   
        },
        getAllMasterSynonyms:{
            url: "/Reports/GetAllMasterSynonyms", method: "GET" 
        }, 
        addSynonyms:{
            url:"/Reports/CreateMasterSynonyms", method: "POST" 
        }
        , 
        updateSynonyms:{
            url:"/Reports/UpdateMasterSynonyms", method: "POST" 
        },
        deleteSynonyms:{
            url:"/Reports/DeleteCreateMasterSynonyms", method: "POST"  
        },
        deleteNotes:
        {
            url: "/Ticket/RemoveConversation" , method: "POST" 
        },
        uploadViaExcelMasterSynonyms:
        {
            url: "/Reports/UploadViaExcelMasterSynonyms" , method: "POST"  
        },
        getMarketPlaceCategory:{
            url: "/MarketplaceExcel/GetAllPlatformsWithCategories", method: "GET" 
        },
        getAttachementsList:{
            url: "/Ticket/GetAttachementsByticketId?ticketId=", method: "POST" 
        },
        getITSupportLocation:{
             url: "/Ticket/GetITSupportLocation", method: "GET" 
        },
        bulkAssigned:{
            url: "/Ticket/BulkAssignTicket", method: "POST"  
        },
        getMasterStatusList:{
            url: "/Common/Status", method: "GET" 
        },
        updateTicketStatus:{
          url: "/Ticket/updateTicketStatus", method: "POST"   
        }



    },  



    of(dataVar: any) {

        let urlPath;

        for (let i in this) {
            if (this[i][dataVar]) {
                let fullUrl = rootPath(i) + this[i][dataVar].url
                urlPath = { ...this[i][dataVar], url: fullUrl };
                break;
            }

        }
        return urlPath;
    }


}




export const menuIcon = {
    'dashboard': 'bi bi-display',
    'user-management': 'bi bi-people',
    'role-management': 'bi bi-fingerprint',
    'leads': "bi bi-journal-text",
    'booking': "bi bi-clipboard-check",
    "company-management": "bi bi-wrench-adjustable",
    "active-agent": "bi bi-person-check",
    "activity": "bi bi-bookmark-check",
    "acknowledgement": "bi bi-megaphone",
    "notes": "bi bi-envelope-paper",
    'bulk-email': "bi bi-envelope",
    'interaction-lead': "bi bi-journal-richtext",
    'tickets': "bi bi-pass",
    'reports': "bi bi-clipboard-data",
    "mis-management": 'bi bi-markdown',
    "client-management": 'bi bi-person-video3',
    "sales-management": 'bi bi-journal-bookmark-fill',
    "ameyo-management": "bi bi-headset",
    "chat-management": "bi bi-chat",
    "lims-utility": 'bi bi-tools',
    "agent-details": "bi bi-bookmark-check",
    "it-ticket": 'bi bi-tools',
    "market-place": 'bi-file-earmark-excel',
    "master-synonyms":"bi bi-laptop"



}